import React from "react";
import useLegalInfo from "@/hooks/useLegalInfo";
import { LegalLayout, Section } from "@/components/LegalLayout";
import { COOKIE_POLICY_VERSION, openCookieSettings } from "@/lib/consent";

const COOKIES = [
  ["ap_token / ap_user", "Propia", "Técnica", "Mantener la sesión iniciada", "Hasta cerrar sesión"],
  ["ap_cookie_consent", "Propia", "Técnica", "Recordar tus preferencias de cookies", "12 meses"],
  ["ap_sid", "Propia", "Analítica", "Medir visitas y conversiones de forma agregada", "30 min"],
  ["ph_* (PostHog)", "Tercero", "Analítica", "Analítica de uso del producto", "12 meses"],
];

export default function CookiesPolicy() {
  const { L, info } = useLegalInfo();
  return (
    <LegalLayout kicker={`Versión ${COOKIE_POLICY_VERSION}`} title="Política de Cookies" updated="junio 2026" testid="cookies-policy-page">
      <p>
        Conforme al art. 22.2 de la Ley 34/2002 de Servicios de la Sociedad de la Información (LSSI) y la Guía sobre el uso de cookies
        de la AEPD, te informamos sobre las cookies y tecnologías similares (localStorage) que usa {L("company_name")} en este sitio.
      </p>

      <Section title="1. ¿Qué son las cookies?">
        <p>Son pequeños archivos o datos que se guardan en tu navegador y permiten, por ejemplo, mantener tu sesión o conocer cómo se usa la web.</p>
      </Section>

      <Section title="2. Cookies que utilizamos">
        <div className="overflow-x-auto border border-slate-200">
          <table className="w-full text-xs sm:text-sm" data-testid="cookies-table">
            <thead className="bg-slate-900 text-white">
              <tr>{["Nombre", "Titular", "Tipo", "Finalidad", "Duración"].map((h) => <th key={h} className="text-left p-2 font-bold">{h}</th>)}</tr>
            </thead>
            <tbody className="divide-y divide-slate-200">
              {COOKIES.map((r) => (
                <tr key={r[0]}>{r.map((c, i) => <td key={i} className={`p-2 ${i === 0 ? "font-mono" : ""}`}>{c}</td>)}</tr>
              ))}
            </tbody>
          </table>
        </div>
        <p>Las cookies técnicas son necesarias y no requieren consentimiento. Las analíticas y de marketing <strong>solo se activan si las aceptas</strong> y vienen desactivadas por defecto.</p>
      </Section>

      <Section title="3. Cómo gestionar o retirar el consentimiento">
        <p>Puedes cambiar tu elección en cualquier momento:</p>
        <button onClick={openCookieSettings} className="btn-brand h-11 px-5 font-bold text-sm" data-testid="cookies-policy-open-settings">
          Abrir configuración de cookies
        </button>
        <p>También puedes bloquear o borrar las cookies desde la configuración de tu navegador (Chrome, Firefox, Safari, Edge). Si bloqueas las técnicas, algunas funciones pueden dejar de funcionar.</p>
      </Section>

      <Section title="4. Más información">
        <p>Para cualquier duda escribe a {L("email")}. Consulta también nuestra Política de Privacidad.</p>
      </Section>
    </LegalLayout>
  );
}
